<div class="dev-controls-container" [class.expanded]="devMode()">

    <div class="inputs-container">
      @if(!animationStarted()){
        <div class="checkbox-container input-image" >
            <label class="inputlabels">Real Time</label>
            <input type="checkbox" (focusin)="focusin($event)" [checked]="isFakeGPSActive()" class="inputs-checkbox-dev-mode" (change)="toggleGPSTrack($event)" />
            <span class="check-mark"></span>
        </div>
        @if (isFakeGPSActive()){
          <div class="checkbox-container input-image" >
            <label class="inputlabels">Manual Hour</label>
            <input type="checkbox" (focusin)="focusin($event)" [checked]="!isRealHour()" class="inputs-checkbox-dev-mode" (change)="toggleRealHour()" />
            <span class="check-mark"></span>
          </div>

          @if (!isRealHour()){
          <div class="time-container">
              <input type="text" readonly [value]="manualHour()" />
              <button (click)="decreaseTime()"> - </button>
              <button (click)="increaseTime()"> + </button>
            </div>
          }

          <div class="checkbox-container input-image" >
            <label class="inputlabels">Manual Project Point</label>
            <input type="checkbox" (focusin)="focusin($event)" [checked]="canSetMarkerFromMap()" class="inputs-checkbox-dev-mode" (change)="toggleAllowAddMarker()" />
            <span class="check-mark"></span>
          </div>

          @if(canSetMarkerFromMap() && runningSegment()){
            <div class="time-container">
              @if(!animationRequestId){
                <button (click)="startSimulateStep()">SIMULATE STEP</button>
              }
              @else {
                  <button class="stop" (click)="stopSimulateStep()">STOP</button>
              }
            </div>
          }
        }
      }
      @else {
        <div class="time-container">
          <button class="stop" (click)="stopSimulateStep()">STOP</button>
        </div>
      }  

    </div>

    <button class="expand-dev-controls"  (click)="toggleDevMode()">
        <ci-icon [class.expanded]="devMode()" type="svg" name="down" scale="2x"></ci-icon>
    </button>
    
</div>

